import { Typography } from '@mui/material';
import styled from 'styled-components';

export const Title = styled(Typography).attrs({ variant: 'h6' })``;
